<div class="flex flex-col gap-4">
<h2 class="text-center text-xl">{{inputGoal ? 'Update' : 'Add'}} {{goalType}} Goal</h2>
  <form [formGroup]="goalForm"
        class="flex flex-col w-full"
        (ngSubmit)="submit()"
        [appEnterKeySubmit]="goalForm"
        [onSubmit]="submit.bind(this)"
  >
    <tandem-form-input [inputType]="'text'"
                       [form]="goalForm"
                       [label]="'Name'"
                       [controlName]="'name'"
                       [inputId]="'name'"
                       [autoFocus]="true"
                       placeholder="Name"></tandem-form-input>
    <tandem-form-input [inputType]="'date'"
                       [form]="goalForm"
                       [label]="'Start Date'"
                       [controlName]="'startDate'"
                       [inputId]="'startDate'"></tandem-form-input>
    <tandem-form-input [inputType]="'date'"
                       [form]="goalForm"
                       [label]="'Target Date'"
                       [controlName]="'targetDate'"
                       [inputId]="'targetDate'"></tandem-form-input>
    <div class="flex flex-row gap-6 w-full justify-center">
      <tandem-button theme="outline" color="white" [onClick]="close.bind(this)">Cancel</tandem-button>
      <tandem-button theme="outline" color="primary" [onClick]="submit.bind(this)" [disabled]="goalForm.invalid" type="submit">{{inputGoal ? 'Update' : 'Create'}}</tandem-button>
    </div>
  </form>
</div>
